exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit_pic_temp[data-v-d756ff82] {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  /* z-index: -1; */\r\n  border: 1px dashed #3089dc;\r\n  cursor: move;\n}\n.edit_point[data-v-d756ff82] {\r\n  background-color: #fff;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  position: absolute;\r\n  z-index: 1001;\r\n  display: block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: 1px solid #3089dc;\n}\r\n", ""]);

// exports
